module.exports = __webpack_public_path__ + "static/landing-page-logo-1c1f974e5d7cc681b295c0a060cba565.svg";